import { render, staticRenderFns } from "./LevyCalculation.vue?vue&type=template&id=4b6e50d0&"
import script from "./LevyCalculation.vue?vue&type=script&lang=js&"
export * from "./LevyCalculation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports